import { api } from 'api';
import {
  SettlementEmailTemplate,
  SettlementEmailTemplateDefault,
} from 'api/endpoints/settlementEmailTemplates';

export const apiSettlementEmailTemplates = {
  get: async () => {
    const result = await api.settlementEmailTemplates.get();
    return result?.map(convertTokenToHtml);
  },

  getDefaultTemplate: async (id: number) => {
    const result = await api.settlementEmailTemplates.getDefaultTemplate(id);
    return convertDefaultTokenToHtml(result);
  },

  put: (id: number, data: SettlementEmailTemplate) => {
    const toSend = convertHtmlToToken(data);
    return api.settlementEmailTemplates.put(id, toSend);
  },

  resetDefault: (id: number) => {
    return api.settlementEmailTemplates.resetDefault(id);
  },
};

/***
 * Quick fix
 * in the template text we have the next token {{> xxxxx}}
 *       that must be shown as {{&gt; xxxxx}} in the HTML text
 */
const convertTokenToHtml = <T extends SettlementEmailTemplate | undefined>(
  item: T,
): T => {
  if (!item) return item;
  const result: T = {
    ...item,
    subject: replaceTokenToHtml(item.subject),
    template: replaceTokenToHtml(item.template),
  };
  return result;
};

const convertDefaultTokenToHtml = <
  T extends SettlementEmailTemplateDefault | undefined,
>(
  item: T,
): T => {
  if (!item) return item;
  const result: T = {
    ...item,
    defaultSubject: replaceTokenToHtml(item.defaultSubject),
    defaultTemplate: replaceTokenToHtml(item.defaultTemplate),
  };
  return result;
};

const convertHtmlToToken = <T extends SettlementEmailTemplate | undefined>(
  item: T,
): T => {
  if (!item) return item;
  const result: T = {
    ...item,
    subject: replaceHtmlToToken(item.subject),
    template: replaceHtmlToToken(item.template),
  };
  return result;
};

const replaceTokenToHtml = (text: string) => text.replaceAll('{{>', '{{&gt;');
const replaceHtmlToToken = (text: string) => text.replaceAll('{{&gt;', '{{>');
